(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ambreux-offer-home"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = (root) => {
      if (!root || root.dataset.abReady === 'true') return;
      root.dataset.abReady = 'true';
      document.body.classList.add('ab-page-active');

      const duration = Math.max(1, Number(root.dataset.timerHours || 48)) * 60 * 60 * 1000;
      const storageKey = `ambreux-offer-deadline-${root.dataset.sectionId}`;
      let deadline;
      try { deadline = Number(localStorage.getItem(storageKey)); } catch (error) { deadline = 0; }
      if (!deadline || deadline <= Date.now()) {
        deadline = Date.now() + duration;
        try { localStorage.setItem(storageKey, String(deadline)); } catch (error) {}
      }

      const values = {
        days: root.querySelector('[data-ab-days]'),
        hours: root.querySelector('[data-ab-hours]'),
        minutes: root.querySelector('[data-ab-minutes]'),
        seconds: root.querySelector('[data-ab-seconds]')
      };
      const renderTimer = () => {
        let remaining = Math.max(0, deadline - Date.now());
        if (remaining === 0) {
          deadline = Date.now() + duration;
          remaining = duration;
          try { localStorage.setItem(storageKey, String(deadline)); } catch (error) {}
        }
        const days = Math.floor(remaining / 86400000);
        const hours = Math.floor((remaining % 86400000) / 3600000);
        const minutes = Math.floor((remaining % 3600000) / 60000);
        const seconds = Math.floor((remaining % 60000) / 1000);
        if (values.days) values.days.textContent = String(days).padStart(2, '0');
        if (values.hours) values.hours.textContent = String(hours).padStart(2, '0');
        if (values.minutes) values.minutes.textContent = String(minutes).padStart(2, '0');
        if (values.seconds) values.seconds.textContent = String(seconds).padStart(2, '0');
      };
      renderTimer();
      root.abTimer = window.setInterval(renderTimer, 1000);

      root.querySelectorAll('[data-ab-cart]').forEach((trigger) => {
        trigger.addEventListener('click', (event) => {
          const drawer = document.querySelector('cart-drawer');
          if (drawer && typeof drawer.open === 'function') {
            event.preventDefault();
            drawer.open(trigger);
          }
        });
      });

      const rail = root.querySelector('[data-ab-accessories]');
      const moveRail = (direction) => {
        if (!rail) return;
        rail.scrollBy({ left: direction * rail.clientWidth * 0.84, behavior: 'smooth' });
      };
      root.querySelector('[data-ab-prev]')?.addEventListener('click', () => moveRail(-1));
      root.querySelector('[data-ab-next]')?.addEventListener('click', () => moveRail(1));
      root.querySelector('[data-ab-shop]')?.addEventListener('click', () => {
        root.querySelector('.ab-products')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    };

    document.querySelectorAll('.ab-home').forEach(init);
    document.addEventListener('shopify:section:load', (event) => init(event.target.querySelector('.ab-home')));
    document.addEventListener('shopify:section:unload', (event) => {
      const root = event.target.querySelector('.ab-home');
      if (root?.abTimer) window.clearInterval(root.abTimer);
      window.setTimeout(() => {
        if (!document.querySelector('.ab-home')) document.body.classList.remove('ab-page-active');
      }, 0);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["drivtown-wallet-product"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('dt-wallet-legacy-benefits')) {
  customElements.define('dt-wallet-legacy-benefits', class extends HTMLElement {
    connectedCallback() {
      if (this._mounted) return;
      this._mounted = true;
      const delivery = this.querySelector('[data-abx-delivery]');
      const dateAfter = days => { const date = new Date(); date.setDate(date.getDate() + Number(days)); return date; };
      const from = dateAfter(delivery.dataset.min);
      const to = dateAfter(delivery.dataset.max);
      const formatter = new Intl.DateTimeFormat('en-GB', {month:'long', day:'numeric'});
      const sameMonth = from.getMonth() === to.getMonth() && from.getFullYear() === to.getFullYear();
      delivery.textContent = (sameMonth ? from.getDate() : formatter.format(from)) + ' and ' + formatter.format(to);
      const rail = this.querySelector('[data-benefit-slides]');
      const buttons = [...this.querySelectorAll('[data-benefit-index]')];
      buttons.forEach((button,index) => button.addEventListener('click', () => rail.scrollTo({left:rail.clientWidth * index, behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'})));
      rail.addEventListener('scroll', () => { const index = Math.round(rail.scrollLeft / rail.clientWidth); buttons.forEach((button,i) => button.setAttribute('aria-current', String(i === index))); }, {passive:true});
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
